console.log('%cBuilt by Not selling liquid', 'color:#000; font-weight:bold;');

/* ── Centralized drawer/overlay state ─────────────────────────────
   Filter, Menu, Search and Cart drawers (plus the mobile Quick Add
   modal) all share the same panel/backdrop z-index (1000 / 997) and the
   same `.overlay-box` element, so whichever ones are "open" at once are
   only kept apart by which body classes are present. Every drawer's own
   open handler used to hand-list which OTHER classes to remove, and it
   was easy for one of them (e.g. the hamburger menu toggle) to miss one —
   leaving two drawers simultaneously visible at the same z-index, with
   the DOM's paint order deciding which one visually won.

   Removing the body class alone isn't enough for every drawer, though —
   the Filter Drawer's panel visibility is driven entirely by its own
   `aria-hidden` attribute (assets/collection.css), independent of any
   body class. So besides the shared class list, drawers with their own
   close routine (focus restore, aria-hidden, accordion resets, …)
   register it via window.registerDrawerCloser(); closeOtherDrawers()
   runs both the class cleanup and every other drawer's real close
   function, so each drawer fully tears down its own state instead of
   only losing the CSS hook that happened to hide it. */
var SM_DRAWER_BODY_CLASSES = [
  'open-filter',
  'open-menu',
  'open-search-drawer',
  'open-search',
  'open-drawer',
  'open-cart',
  'open-sort',
  'open-quick-modal',
  'quick-modal-header-behind'
];

var SM_DRAWER_CLOSERS = {};

window.registerDrawerCloser = function (bodyClass, closeFn) {
  SM_DRAWER_CLOSERS[bodyClass] = closeFn;
};

window.closeOtherDrawers = function (exceptClasses) {
  var keep = [].concat(exceptClasses || []);

  Object.keys(SM_DRAWER_CLOSERS).forEach(function (cls) {
    if (keep.indexOf(cls) === -1) SM_DRAWER_CLOSERS[cls]();
  });

  var toRemove = SM_DRAWER_BODY_CLASSES.filter(function (cls) {
    return keep.indexOf(cls) === -1;
  });
  document.body.classList.remove.apply(document.body.classList, toRemove);
};

var SM_PANEL_PARK_MS = 400;

window.smUnparkPanel = function (el) {
  if (!el) return;
  if (el._smParkTimer) {
    clearTimeout(el._smParkTimer);
    el._smParkTimer = null;
  }
  if (el.style.getPropertyValue('display') === 'none') {
    el.style.removeProperty('display');
    void el.offsetHeight;
  }
};

window.smParkPanel = function (el, immediate) {
  if (!el) return;
  if (el._smParkTimer) {
    clearTimeout(el._smParkTimer);
    el._smParkTimer = null;
  }
  if (immediate) {
    el.style.setProperty('display', 'none', 'important');
    return;
  }
  el._smParkTimer = setTimeout(function () {
    el._smParkTimer = null;
    el.style.setProperty('display', 'none', 'important');
  }, SM_PANEL_PARK_MS);
};

document.addEventListener('DOMContentLoaded', function () {
  var panels = document.querySelectorAll('.cart-sidebar, .search-sidebar');
  Array.prototype.forEach.call(panels, function (panel) {
    window.smParkPanel(panel, true);
  });
});

var SM_SCROLL_LOCK_Y = 0;
var SM_SCROLL_LOCKED = false;

window.smLockBodyScroll = function () {
  if (SM_SCROLL_LOCKED) return;
  SM_SCROLL_LOCK_Y = window.pageYOffset || document.documentElement.scrollTop || 0;
  document.body.style.position = 'fixed';
  document.body.style.top = (-SM_SCROLL_LOCK_Y) + 'px';
  document.body.style.left = '0';
  document.body.style.right = '0';
  document.body.style.width = '100%';
  SM_SCROLL_LOCKED = true;
};

window.smUnlockBodyScroll = function () {
  if (!SM_SCROLL_LOCKED) return;
  SM_SCROLL_LOCKED = false;
  document.body.style.position = '';
  document.body.style.top = '';
  document.body.style.left = '';
  document.body.style.right = '';
  document.body.style.width = '';
  window.scrollTo(0, SM_SCROLL_LOCK_Y);
};

if(document.querySelectorAll('.variant-grid')){
  function quickAddButton(){
    document.querySelectorAll('.variant-grid').forEach(function(sizeList){
      sizeList.addEventListener('click',function(e){
        e.preventDefault();
        let variant_id = sizeList.dataset.id;
        let error_grid_outer = sizeList.closest('.snippet-product-card');
        let error_grid = error_grid_outer.querySelector('.grid-error');
        let formData = {
          'items': [{
            'id': variant_id,
            'quantity': 1
          }]
        };
        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(formData),
        })
        .then((response) => response.json())
        .then((data) => {
          if(data.status == 422)
          {
            error_grid.innerHTML = data.description;
            setTimeout(function(e){
              error_grid.innerHTML = '';
            },2000);
          }else{          
            if(document.location.href.indexOf('/cart') > -1) {
              window.location.href = "/cart";
            }else{
              if(typeof load_cart == 'function'){
                load_cart().then(function() {
                  if(typeof openCartDrawer == 'function') openCartDrawer();
                });
              }else{
                window.location.href = "/cart";
              }          
            }
            const url = '/cart.js';
            fetch(url)
            .then((resp) => resp.json())
            .then(function(data) {
              var cart_count = cartItemCount(data);
              if(cart_count>0){
                document.querySelector('.cart-count').innerHTML = cart_count;
              }else{
                document.querySelector('.cart-count').innerHTML = '';
              }
            })
            .catch(function(error) {
              console.log(error);
            })
          }
        })
        .catch((error) => {
          console.error(error);
        });
      });
    });    
//     document.querySelectorAll('.quick-add').forEach(function(quickAdd){
//       quickAdd.onclick = function(){
//         document.querySelectorAll('.snippet-product-grid').forEach(function(everyProduct){       
//           everyProduct.classList.remove('active-quick');
//         });
//         let gridimgbox = quickAdd.closest('.snippet-product-grid');      
//         gridimgbox.classList.add('active-quick');
//       };
//     });
  }
  quickAddButton();
}
class PredictiveSearch extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="text"]');
    this.predictiveSearchResults = document.querySelector('#predictive-search');
    this.input.addEventListener('focus', () => {
        document.body.classList.add('open-suggetion');
    });
    this.input.addEventListener('blur', () => {
        document.body.classList.remove('open-suggetion');
    })
    this.input.addEventListener('input', this.debounce((event) => {
      this.onChange(event);
      var input_length = this.input.value.length;
      if(input_length>0){
        document.querySelectorAll('.search-Button').forEach(function(SeachButtons){
          SeachButtons.disabled = false;
        });
      }else{
        document.querySelectorAll('.search-Button').forEach(function(SeachButtons){
          SeachButtons.disabled = true;
        });
      } 
    }, 300).bind(this));
  }
  onChange() {
    const searchTerm = this.input.value.trim();
    if (!searchTerm.length) {
      this.close();
      return;
    }
    this.getSearchResults(searchTerm);
  }
  getSearchResults(searchTerm) {
    fetch(`/search/suggest?q=${searchTerm}&resources[type]=product&resources[limit]=4&section_id=predictive-search`)
    .then((response) => {
      if (!response.ok) {
        var error = new Error(response.status);
        this.close();
        throw error;
      }
      return response.text();
    })
    .then((text) => {
      const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;
      this.predictiveSearchResults.innerHTML = resultsMarkup;
      this.open();
      if(typeof quickAddButton == 'function'){
        quickAddButton();
      }
      if(document.getElementById('SearchValue')){
        document.getElementById('SearchValue').value = searchTerm;
      }           
    })
    .catch((error) => {
      this.close();
      throw error;
    });
  }
  open() {
    this.predictiveSearchResults.style.display = 'block';
    document.querySelector('.search-suggetion').style.display = "none";
}
close() {
    this.predictiveSearchResults.style.display = 'none';
    document.querySelector('.search-suggetion').style.display = "block";
  }
  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}
customElements.define('predictive-search', PredictiveSearch);

/* ── Product Card Interactions (Splide, Size Variants, Shades, Quick Add) ── */
(function () {
  'use strict';

  var SPLIDE_OPTIONS = {
    type: 'fade',
    perPage: 1,
    pagination: false,
    arrows: true,
    /* Overridden per card in mountCardSplide - a card nested in an outer
       carousel stays arrow-only, a standalone one is swipeable on touch. */
    drag: false,
    /* rewind must stay off: with it on, Splide treats index 0 as having a
       previous slide (the last one) and never disables an arrow. */
    rewind: false,
    focusableNodes: '',
    speed: 200,
    easing: 'ease'
  };

  var cardVideoObserver = null;

  function loadCardVideo(video) {
    if (video._cardVideoLoaded) return;
    video._cardVideoLoaded = true;
    var pending = video.querySelectorAll('source[data-src]');
    if (!pending.length) return;
    Array.prototype.forEach.call(pending, function (source) {
      source.src = source.dataset.src;
      source.removeAttribute('data-src');
    });
    video.load();
  }

  function playCardVideo(video) {
    loadCardVideo(video);
    if (!video.paused) return;
    var playing = video.play();
    if (playing && playing.catch) playing.catch(function () {});
  }

  function isCardVideoShown(video) {
    var slide = video.closest('.splide__slide');
    return !slide || slide.classList.contains('is-active');
  }

  function onCardVideoIntersect(entries) {
    entries.forEach(function (entry) {
      var video = entry.target;
      if (!video.isConnected) {
        cardVideoObserver.unobserve(video);
        return;
      }
      video._cardVideoInView = entry.isIntersecting;
      if (entry.isIntersecting) {
        if (isCardVideoShown(video)) playCardVideo(video);
      } else if (!video.paused) {
        video.pause();
      }
    });
  }

  function observeCardVideos(root) {
    var videos = root.querySelectorAll('video[data-card-video]');
    if (!videos.length) return;
    if (!('IntersectionObserver' in window)) {
      Array.prototype.forEach.call(videos, playCardVideo);
      return;
    }
    if (!cardVideoObserver) {
      cardVideoObserver = new IntersectionObserver(onCardVideoIntersect, { rootMargin: '200px 0px' });
    }
    Array.prototype.forEach.call(videos, function (video) {
      if (video._cardVideoObserved) return;
      video._cardVideoObserved = true;
      cardVideoObserver.observe(video);
    });
  }

  function hydrateCardMedia(card) {
    if (!card || card._cardMediaHydrated) return;
    card._cardMediaHydrated = true;
    Array.prototype.forEach.call(card.querySelectorAll('img[data-srcset], img[data-src]'), function (img) {
      if (img.dataset.srcset) {
        img.srcset = img.dataset.srcset;
        img.removeAttribute('data-srcset');
      }
      if (img.dataset.src) {
        img.src = img.dataset.src;
        img.removeAttribute('data-src');
      }
    });
    Array.prototype.forEach.call(card.querySelectorAll('video[data-poster]'), function (video) {
      video.poster = video.dataset.poster;
      video.removeAttribute('data-poster');
    });
  }

  /* ── Splide ─────────────────────────────────────────────────── */

  /**
   * Mount one card slider. The Splide instance is created from the element
   * itself (never from a '#id' selector) so that duplicate product ids —
   * e.g. the same product rendered in the grid and in the search drawer —
   * can never make one card's arrows drive another card's slider.
   */
  function mountCardSplide(el) {
    if (el.classList.contains('is-splide-mounted')) return;

    /* A single image needs no slider: mark it done and leave the markup be. */
    var slides = el.querySelectorAll('.splide__list > .splide__slide');
    if (slides.length < 2) {
      el.classList.add('is-splide-mounted', 'is-single-slide');
      return;
    }

    /* The same product can render twice (grid + search drawer), producing a
       duplicate root id. Drop the loser's id so Splide generates a unique one
       and the slide ids it derives from it cannot collide. */
    if (el.id && document.getElementById(el.id) !== el) {
      el.removeAttribute('id');
    }

    el.classList.add('is-splide-mounted');

    /* Hover-to-second-image is a desktop-mouse affordance only. On touch
       devices, tapping a Prev/Next arrow on an outer slider (e.g. Complete
       Your Bag / Product Recommendations) shifts cards under the resting
       finger via CSS transform; the browser then fires a synthetic
       mouseenter at that point, silently swapping this card's image too.
       Gating on a real hover-capable pointer avoids that misfire. It is the
       same query product-card.css uses to hide the arrows on desktop, so
       every device keeps exactly one working mechanism. */
    var supportsHover = !window.matchMedia || window.matchMedia('(hover: hover) and (pointer: fine)').matches;

    /* A card rendered inside an outer carousel (Featured Products Row,
       Product Recommendations, Complete Your Bag, Featured Products Grid,
       Featured Products With Visual, Favorites) must never be draggable
       itself: a horizontal swipe there belongs to the outer slider, and two
       nested drag handlers would fight over the same gesture. Those cards
       stay arrow-only. A standalone card — collection grid, search results,
       search drawer — owns the horizontal gesture, so on touch its media is
       swipeable as well as arrow-driven.

       `el` itself carries the `splide` class, so the lookup has to start at
       the parent, otherwise every card would match itself. */
    var isInsideOuterSlider = !!(el.parentElement && el.parentElement.closest('.splide'));
    var allowDrag = !supportsHover && !isInsideOuterSlider;

    try {
      var cardOptions = Object.assign({}, SPLIDE_OPTIONS, { drag: allowDrag });
      var slider = new Splide(el, cardOptions);

      /* Splide flags the first/last slide by setting the native `disabled`
         property on the arrow. We deliberately clear it again and express the
         state with `is-disabled` + aria-disabled instead: a natively disabled
         button is dropped from hit-testing, so `cursor: not-allowed` never
         paints and the pointer falls through to the <a class="product-link">
         behind the arrow, showing a hand cursor. Keeping the button enabled
         keeps it hoverable; clicks are cancelled in the capture listener
         below. Bound before mount() so the initial state is caught too —
         Splide emits this on mount and on every slide change. */
      slider.on('arrows:updated', function (prev, next) {
        [prev, next].forEach(function (arrow) {
          var isDisabled = arrow.disabled;
          arrow.disabled = false;
          arrow.classList.toggle('is-disabled', isDisabled);
          arrow.setAttribute('aria-disabled', isDisabled ? 'true' : 'false');
        });
      });

      slider.on('move', function (newIndex) {
        if (!supportsHover || newIndex > 1) {
          hydrateCardMedia(el.closest('.snippet-product-card') || el);
        }
      });

      slider.on('active', function (slide) {
        var video = slide.slide.querySelector('video[data-card-video]');
        if (video && video._cardVideoInView) playCardVideo(video);
      });

      slider.on('inactive', function (slide) {
        var video = slide.slide.querySelector('video[data-card-video]');
        if (video && !video.paused) video.pause();
      });

      var mountedSlider = slider.mount();
      el.splideInstance = mountedSlider;

      el.classList.toggle('is-draggable', allowDrag);

      if (supportsHover) {
        var cardBox = el.closest('.product-images') || el.closest('.snippet-product-card') || el;

        cardBox.addEventListener('mouseenter', function () {
          if (mountedSlider.index === 0 && slides.length > 1) {
            mountedSlider.go(1);
          }
        });

        cardBox.addEventListener('mouseleave', function () {
          if (slides.length > 1) {
            mountedSlider.go(0);
          }
        });
      }
    } catch (e) {
      el.classList.remove('is-splide-mounted');
      console.error('Product card Splide mount error:', e);
    }
  }

  var splideWaitTimer = null;

  function initProductCardSplides(container) {
    var root = container || document;
    observeCardVideos(root);
    var els = root.querySelectorAll('.js-product-card-splide:not(.is-splide-mounted)');
    if (!els.length) return;

    /* splide.js is loaded with defer — retry briefly until it is available. */
    if (typeof Splide === 'undefined') {
      if (splideWaitTimer) return;
      var tries = 0;
      splideWaitTimer = setInterval(function () {
        tries++;
        if (typeof Splide !== 'undefined' || tries > 50) {
          clearInterval(splideWaitTimer);
          splideWaitTimer = null;
          if (typeof Splide !== 'undefined') initProductCardSplides();
        }
      }, 100);
      return;
    }

    Array.prototype.forEach.call(els, mountCardSplide);
  }

  /* collection.js / search-drawer.js call this by name after AJAX renders. */
  window.initProductCardSplides = initProductCardSplides;

  function hydrateCardFromEvent(e) {
    if (e.type === 'pointerdown' && e.pointerType === 'mouse') return;
    var target = e.target;
    var card = target && target.closest ? target.closest('.snippet-product-card') : null;
    if (card) hydrateCardMedia(card);
  }

  document.addEventListener('touchstart', hydrateCardFromEvent, { passive: true });
  document.addEventListener('pointerdown', hydrateCardFromEvent, { passive: true });
  document.addEventListener('focusin', hydrateCardFromEvent);

  /* ── Variant data & resolution ──────────────────────────────── */

  function getVariants(card) {
    if (card._cardVariants) return card._cardVariants;
    var node = card.querySelector('.js-card-variant-data');
    var data = [];
    if (node) {
      try {
        data = JSON.parse(node.textContent) || [];
      } catch (e) {
        console.error('Product card variant data parse error:', e);
      }
    }
    card._cardVariants = data;
    return data;
  }

  function findVariantById(card, id) {
    var variants = getVariants(card);
    for (var i = 0; i < variants.length; i++) {
      if (String(variants[i].id) === String(id)) return variants[i];
    }
    return null;
  }

  function getSizeIndex(card) {
    var idx = parseInt(card.dataset.sizeOptionIndex, 10);
    return isNaN(idx) ? -1 : idx;
  }

  /** Option values currently selected on this card, seeded from the active variant. */
  function getSelectedOptions(card) {
    if (!card._selectedOptions) {
      var current = findVariantById(card, card.dataset.activeVariantId);
      card._selectedOptions = current ? current.options.slice() : [];
    }
    return card._selectedOptions;
  }

  /**
   * Find the variant for a newly picked size, keeping every other option
   * (shade, colour, …) on its current value. Falls back to the first variant
   * carrying that size when the exact combination does not exist.
   */
  function resolveVariantForSize(card, sizeIndex, sizeValue) {
    var variants = getVariants(card);
    var selected = getSelectedOptions(card);
    var partial = null;

    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      if (v.options[sizeIndex] !== sizeValue) continue;
      if (!partial) partial = v;

      var matchesRest = true;
      for (var j = 0; j < selected.length; j++) {
        if (j === sizeIndex) continue;
        if (selected[j] && v.options[j] !== selected[j]) { matchesRest = false; break; }
      }
      if (matchesRest) return v;
    }

    return partial;
  }

  /* ── Card state ─────────────────────────────────────────────── */

  function updateCardVariant(card, variant) {
    if (!card || !variant) return;

    card.dataset.activeVariantId = variant.id;
    card._selectedOptions = variant.options.slice();

    var showSoldOut = !variant.available && !card.hasAttribute('data-hide-sold-out');

    var cartBtn = card.querySelector('.js-card-quick-add');
    if (cartBtn) {
      cartBtn.dataset.variantId = variant.id;
      cartBtn.classList.toggle('is-disabled', showSoldOut);
    }
    card.classList.toggle('is-sold-out', showSoldOut);

    var priceEl = card.querySelector('.js-card-price');
    if (priceEl && variant.price) priceEl.innerHTML = variant.price;

    /* The trigger shows the selected size and stays that way until changed. */
    var sizeIndex = getSizeIndex(card);
    var sizeValue = sizeIndex > -1 ? variant.options[sizeIndex] : null;

    if (sizeValue) {
      var labelEl = card.querySelector('.js-selected-size-label');
      if (labelEl) labelEl.textContent = sizeValue;

      card.querySelectorAll('.js-size-option').forEach(function (opt) {
        var isSelected = opt.dataset.sizeValue === sizeValue;
        opt.classList.toggle('is-selected', isSelected);
        opt.setAttribute('aria-selected', isSelected ? 'true' : 'false');
      });
    }

    card.querySelectorAll('.js-shade-dot').forEach(function (dot) {
      dot.classList.toggle('is-active', dot.dataset.variantId === String(variant.id));
    });

    /* Only the static (non-slider) layout has a swappable hero image. */
    if (variant.image) {
      var mainImg = card.querySelector('.product-images .main-image');
      if (mainImg) mainImg.src = variant.image;
    }

    if (card.hasAttribute('data-variant-card')) {
      var titleLink = card.querySelector('.product-card__title a');
      if (titleLink && variant.title) titleLink.textContent = card.dataset.cardTitle + ' - ' + variant.title;

      if (variant.url) {
        card.dataset.productUrl = variant.url;
        card.querySelectorAll('a.product-link, .product-card__title a').forEach(function (link) {
          link.setAttribute('href', variant.url);
        });
      }

      var item = card.closest('.product-item');
      if (item) item.dataset.variantId = variant.id;

      var firstImg = card.querySelector('.splide__slide:first-child img');
      if (firstImg && variant.image) {
        firstImg.removeAttribute('srcset');
        firstImg.src = variant.image;
      }
    }
  }

  /* ── Size dropdown ──────────────────────────────────────────── */

  function closeAllSizeDropdowns(except) {
    document.querySelectorAll('.product-card__variant-wrapper').forEach(function (wrapper) {
      if (wrapper === except) return;
      var dropdown = wrapper.querySelector('.js-size-dropdown');
      var trigger = wrapper.querySelector('.js-size-trigger');
      if (dropdown) dropdown.style.display = 'none';
      if (trigger) {
        trigger.classList.remove('is-open');
        trigger.setAttribute('aria-expanded', 'false');
      }
    });
  }

  function toggleSizeDropdown(trigger) {
    var wrapper = trigger.closest('.product-card__variant-wrapper');
    if (!wrapper) return;

    var dropdown = wrapper.querySelector('.js-size-dropdown');
    if (!dropdown) return;

    var willOpen = dropdown.style.display === 'none' || dropdown.style.display === '';

    closeAllSizeDropdowns(wrapper);

    dropdown.style.display = willOpen ? 'block' : 'none';
    trigger.classList.toggle('is-open', willOpen);
    trigger.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
  }

  /* ── Quick add ──────────────────────────────────────────────── */

  function handleCardQuickAdd(btn) {
    if (btn.classList.contains('is-disabled') || btn.disabled) return;

    var card = btn.closest('.snippet-product-card');
    var variantId = btn.dataset.variantId || (card ? card.dataset.activeVariantId : null);
    if (!variantId) return;

    /* On Mobile (<= 991px), open Mobile Quick Add Modal Drawer */
    if (window.innerWidth <= 991 && typeof openQuickAddModal === 'function') {
      var variants = getVariants(card);
      var currentVariant = findVariantById(card, variantId) || (variants ? variants[0] : null);
      var titleEl = card ? card.querySelector('.product-card__title a') : null;
      var priceEl = card ? card.querySelector('.js-card-price') : null;
      var mainImg = card ? card.querySelector('.product-images img') : null;

      var productUrl = card && card.dataset.productUrl ? card.dataset.productUrl : (titleEl ? titleEl.getAttribute('href') : '#');
      var productHandle = card && card.dataset.productHandle ? card.dataset.productHandle : (typeof getProductHandleFromUrl === 'function' ? getProductHandleFromUrl(productUrl) : '');

      openQuickAddModal({
        trigger: 'card-quick-add',
        triggerEl: btn,
        variantId: variantId,
        productId: card ? card.dataset.productId : null,
        handle: productHandle,
        productHandle: productHandle,
        title: titleEl ? titleEl.textContent.trim() : '',
        price: priceEl ? priceEl.innerHTML.trim() : (currentVariant ? currentVariant.price : ''),
        variant: currentVariant ? currentVariant.options.join(' / ') : '',
        image: mainImg ? mainImg.src : (currentVariant ? currentVariant.image : ''),
        url: productUrl,
        available: currentVariant ? currentVariant.available : true
      });
      return;
    }

    var errorGrid = card ? card.querySelector('.grid-error') : null;
    btn.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    })
      .then(function (res) { return res.json(); })
      .then(function (data) {
        btn.disabled = false;

        if (data.status === 422) {
          if (errorGrid) {
            errorGrid.style.display = 'block';
            errorGrid.innerHTML = data.description || 'Could not add to cart';
            setTimeout(function () {
              errorGrid.style.display = 'none';
              errorGrid.innerHTML = '';
            }, 3000);
          }
          return;
        }

        if (window.location.href.indexOf('/cart') > -1) {
          window.location.href = '/cart';
        } else if (typeof load_cart === 'function') {
          load_cart().then(function () {
            if (typeof openCartDrawer === 'function') openCartDrawer();
          });
        } else if (typeof openCartDrawer === 'function') {
          openCartDrawer();
        } else {
          window.location.href = '/cart';
        }

        fetch('/cart.js')
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            var count = cartItemCount(cart);
            document.querySelectorAll('.cart-count, .header-cart-count').forEach(function (el) {
              el.textContent = count > 0 ? count : '';
            });
          })
          .catch(console.error);
      })
      .catch(function (err) {
        btn.disabled = false;
        console.error(err);
      });
  }

  /* ── Delegated events ───────────────────────────────────────── */

  /**
   * Swallow clicks on a disabled arrow. Runs in the CAPTURE phase so it fires
   * before the target-phase handler Splide binds on the arrow itself, and
   * before the click can reach the product link underneath. Also covers
   * keyboard activation, since Enter/Space on a button dispatches a click.
   */
  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    var arrow = e.target.closest('.product-card__splide .splide__arrow');
    if (arrow && arrow.getAttribute('aria-disabled') === 'true') {
      e.preventDefault();
      e.stopImmediatePropagation();
    }
  }, true);

  document.addEventListener('click', function (e) {
    var quickAddBtn = e.target.closest('.js-card-quick-add');
    if (quickAddBtn) {
      e.preventDefault();
      e.stopPropagation();
      handleCardQuickAdd(quickAddBtn);
      return;
    }

    var sizeTrigger = e.target.closest('.js-size-trigger');
    if (sizeTrigger) {
      e.preventDefault();
      e.stopPropagation();
      toggleSizeDropdown(sizeTrigger);
      return;
    }

    var sizeOption = e.target.closest('.js-size-option');
    if (sizeOption) {
      e.preventDefault();
      e.stopPropagation();
      if (sizeOption.classList.contains('is-disabled')) return;

      var sizeCard = sizeOption.closest('.snippet-product-card');
      var sizeIndex = sizeCard ? getSizeIndex(sizeCard) : -1;
      if (sizeCard && sizeIndex > -1) {
        var variant = resolveVariantForSize(sizeCard, sizeIndex, sizeOption.dataset.sizeValue);
        if (variant) updateCardVariant(sizeCard, variant);
      }
      closeAllSizeDropdowns();
      return;
    }

    var shadeDot = e.target.closest('.js-shade-dot');
    if (shadeDot) {
      e.preventDefault();
      e.stopPropagation();
      var shadeCard = shadeDot.closest('.snippet-product-card');
      if (shadeCard) {
        updateCardVariant(shadeCard, findVariantById(shadeCard, shadeDot.dataset.variantId));
      }
      return;
    }

    if (!e.target.closest('.product-card__variant-wrapper')) {
      closeAllSizeDropdowns();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeAllSizeDropdowns();
  });

  /* ── Init ───────────────────────────────────────────────────── */

  function init() { initProductCardSplides(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  window.addEventListener('load', init);

  /**
   * Product cards are also injected by AJAX (collection filter/pagination,
   * predictive search, search drawer). Watch for new cards so every one of
   * them gets its own slider without touching those scripts.
   */
  if ('MutationObserver' in window) {
    var pending = false;
    new MutationObserver(function (mutations) {
      if (pending) return;
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var node = added[j];
          if (node.nodeType !== 1) continue;
          if (node.matches('.js-product-card-splide') || node.querySelector('.js-product-card-splide')) {
            pending = true;
            requestAnimationFrame(function () {
              pending = false;
              initProductCardSplides();
            });
            return;
          }
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }
})();

document.querySelectorAll('.mobile-search').forEach(function(searchButton){
  searchButton.addEventListener('click',function(e){
    var opening = !document.body.classList.contains('open-search');
    if (opening) window.closeOtherDrawers(['open-search']);
    document.body.classList.toggle('open-search');
    document.querySelector(".mobile-serachbox #Search").focus();
  });
});

/* ── Video Media Component (Play/Pause & Mute/Unmute) ── */
function updateVideoWrapperState(wrapper, video) {
  if (!wrapper || !video) return;

  if (video.paused) {
    wrapper.classList.remove('is-playing');
    wrapper.classList.add('is-paused');
  } else {
    wrapper.classList.add('is-playing');
    wrapper.classList.remove('is-paused');
  }

  if (video.muted) {
    wrapper.classList.remove('is-unmuted');
    wrapper.classList.add('is-muted');
  } else {
    wrapper.classList.add('is-unmuted');
    wrapper.classList.remove('is-muted');
  }
}

class VideoMedia extends HTMLElement {
  connectedCallback() {
    this.init();
  }

  init() {
    this.video = this.querySelector('video');
    this.wrapper = this.closest('.media-video-wrapper');
    if (!this.wrapper || !this.video) return;

    var self = this;
    var sync = function() {
      updateVideoWrapperState(self.wrapper, self.video);
    };

    sync();
    ['play', 'playing', 'pause', 'volumechange', 'loadedmetadata'].forEach(function(evt) {
      self.video.addEventListener(evt, sync);
    });

    if (this.hasAttribute('lazy')) this.observe();
  }

  observe() {
    var self = this;

    if (!('IntersectionObserver' in window)) {
      this.loadSources();
      return;
    }

    this.observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          self.loadSources();
          if (self.video.paused && self.video.dataset.userPaused !== 'true') {
            self.video.play().catch(function () {});
          }
        } else if (!self.video.paused) {
          self.video.pause();
        }
      });
    }, { rootMargin: '200px 0px' });

    this.observer.observe(this);
  }

  loadSources() {
    if (this.sourcesLoaded) return;
    this.sourcesLoaded = true;

    var pending = this.video.querySelectorAll('source[data-src]');
    if (!pending.length) return;

    pending.forEach(function (source) {
      source.src = source.dataset.src;
      source.removeAttribute('data-src');
    });

    this.video.load();
  }

  disconnectedCallback() {
    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }
  }
}

if (!customElements.get('video-media')) {
  customElements.define('video-media', VideoMedia);
}

/* Delegated click handler for video controls */
document.addEventListener('click', function (e) {
  var toggleBtn = e.target.closest('[data-video-toggle]');
  if (toggleBtn) {
    e.preventDefault();
    e.stopPropagation();
    var wrapper = toggleBtn.closest('.media-video-wrapper');
    if (wrapper) {
      var video = wrapper.querySelector('video');
      if (video) {
        if (video.paused) {
          delete video.dataset.userPaused;
          var host = video.closest('video-media');
          if (host && host.loadSources) host.loadSources();
          video.play().then(function() {
            updateVideoWrapperState(wrapper, video);
          }).catch(function(err){
            console.log(err);
            updateVideoWrapperState(wrapper, video);
          });
        } else {
          video.dataset.userPaused = 'true';
          video.pause();
          updateVideoWrapperState(wrapper, video);
        }
      }
    }
    return;
  }

  var soundBtn = e.target.closest('[data-video-sound-toggle]');
  if (soundBtn) {
    e.preventDefault();
    e.stopPropagation();
    var soundWrapper = soundBtn.closest('.media-video-wrapper');
    if (soundWrapper) {
      var sVideo = soundWrapper.querySelector('video');
      if (sVideo) {
        sVideo.muted = !sVideo.muted;
        updateVideoWrapperState(soundWrapper, sVideo);
      }
    }
    return;
  }
});

